import { plaidGetters } from '@/store/modules/plaid/routines'

export default {
  [plaidGetters.PLAID_ITEMS]: state => state.plaidItems,

  [plaidGetters.PLAID_STATUS]: state => {
    if (!state.plaidItems) return null
    if (!state.plaidItems.length) return 'notIntegrated'
    // BE doesn't return an explicit `status` field. Plaid's `error` field is null when
    // the item is healthy and populated (e.g. ITEM_LOGIN_REQUIRED) when reauth is needed.
    if (state.plaidItems.some(i => !i.error)) return 'connected'
    return 'failed'
  },

  [plaidGetters.PLAID_ACCOUNTS]: state => (state.plaidItems || []).flatMap(item => item.accounts || [])
}
